import React from "react";
import PropTypes from "prop-types";

import { objectValueNotZero, Translate } from "utils";

import Area from "./Area";
import Capacity from "./Capacity";

import styles from "./SpaceSize.css";

const { t } = new Translate();

const AreaPrimary = ({ area, capacity, isUnitBlack, isValueBold }) => (
  <div className={styles.root}>
    <div className={styles.linked}>
      <Area area={area} isUnitBlack={isUnitBlack} isValueBold={isValueBold} />
      {objectValueNotZero(area) && objectValueNotZero(capacity) && (
        <div className={styles.linkingWord}>{t("with")}</div>
      )}
    </div>
    <Capacity capacity={capacity} isUnitBlack={isUnitBlack} isValueBold={isValueBold} />
  </div>
);

AreaPrimary.propTypes = {
  area: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  capacity: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string,
  }),
  isUnitBlack: PropTypes.bool,
  isValueBold: PropTypes.bool,
};

export default AreaPrimary;
